export const signupStep2Schema = {
  fields: [
    {
      name: 'companyName',
      label: 'Company Name',
      type: 'text',
      placeholder: 'Enter your company name',
      required: true,
    },
    {
      name: 'companyShortName',
      label: 'Company Short Name',
      type: 'text',
      placeholder: 'Enter a short name',
      required: true,
    },
    {
      name: 'timeZone',
      label: 'Time Zone',
      type: 'select',
      placeholder: 'Select your time zone',
      required: false,        // no asterisk in the design
      options: [
        { label: 'UTC−12:00', value: 'Etc/GMT+12' },
        { label: 'UTC−11:00', value: 'Etc/GMT+11' },
        { label: 'UTC−10:00', value: 'Etc/GMT+10' },
        /* …all other TZs… */
        { label: 'UTC+00:00', value: 'Etc/UTC' },
        /* … */
        { label: 'UTC+14:00', value: 'Etc/GMT-14' },
      ],
    },
    {
      name: 'taxId',
      label: 'Tax ID',
      type: 'text',
      placeholder: 'Enter your tax ID',
      required: false,        // no asterisk in the design
    },
  ],
  buttons: [
    {
      label: 'Back',
      action: 'back',
      type: 'button',
      className: 'btn-back',
    },
    {
      label: 'Next',
      action: 'next',
      type: 'button',
      className: 'btn-next',
    },
  ],
};
